import {
  FETCH_LEAVE_PRIOR_LIST_REQUEST,
  FETCH_LEAVE_PRIOR_LIST_SUCCESS,
  FETCH_LEAVE_PRIOR_LIST_FAILURE,
  FETCH_NOT_APPROVED_LEAVE_PRIOR_REQUEST,
  FETCH_NOT_APPROVED_LEAVE_PRIOR_SUCCESS,
  FETCH_NOT_APPROVED_LEAVE_PRIOR_FAILURE,
  UPDATE_LEAVE_PRIOR_REQUEST,
  UPDATE_LEAVE_PRIOR_SUCCESS,
  UPDATE_LEAVE_PRIOR_FAILURE,
} from "../constants/LeavePriorConstants";

import LeavePriorService from "../service/LeavePriorService";

// Fetch leave prior list for a date (Leave Approval page)
export const fetchLeavePriorList = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LEAVE_PRIOR_LIST_REQUEST });

    const response = await LeavePriorService.GetLeavePriorList(date);

    dispatch({
      type: FETCH_LEAVE_PRIOR_LIST_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LEAVE_PRIOR_LIST_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch leave prior list",
    });
  }
};

export const fetchNotApprovedLeavePriorList = (filter) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_NOT_APPROVED_LEAVE_PRIOR_REQUEST });

    const params = typeof filter === "string" ? { date: filter } : filter;

    const response = await LeavePriorService.GetNotApprovedLeavePriorList(params);

    dispatch({
      type: FETCH_NOT_APPROVED_LEAVE_PRIOR_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_NOT_APPROVED_LEAVE_PRIOR_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch not approved leave prior list",
    });
  }
};

export const updateLeavePriorList =
  (employees, remarks = "Approved") =>
  async (dispatch) => {
    dispatch({ type: UPDATE_LEAVE_PRIOR_REQUEST });

    const failed = [];

    // Logged user's service no (saved at login)
    const updateBy = localStorage.getItem("employeeId") || "";

    for (const emp of employees) {
      const payload = {
        barcodeNo: emp.BarcodeNo,
        date: emp.Date,
        remarks: remarks || "Approved",
        status: "Y",
        updateBy,
      };

      try {
        await LeavePriorService.UpdateLeavePriorList(payload);
      } catch (error) {
        failed.push(emp.BarcodeNo);
      }
    }

    const successCount = employees.length - failed.length;

    if (failed.length === 0) {
      dispatch({ type: UPDATE_LEAVE_PRIOR_SUCCESS, payload: successCount });
    } else {
      dispatch({
        type: UPDATE_LEAVE_PRIOR_FAILURE,
        payload: `Failed to approve ${failed.length} of ${employees.length}: ${failed.join(", ")}`,
      });
    }

    return { successCount, failed };
  };